import { render, staticRenderFns } from "./DesTable.vue?vue&type=template&id=33846804&scoped=true&"
import script from "./DesTable.vue?vue&type=script&lang=js&"
export * from "./DesTable.vue?vue&type=script&lang=js&"
import style0 from "./DesTable.vue?vue&type=style&index=0&id=33846804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33846804",
  null
  
)

export default component.exports